export const SEARCH_UNIVERSE = {
    EQUITY: "EQUITY",
    FIXED_INCOME: "FIXED_INCOME",
    FX: "FX"
};

export const RECOMMENDABLE_TYPE = {
    EQUITY: "EQUITY",
    BOND: "BOND",
    ISSUER: "ISSUER",
    SOVEREIGNTY: "SOVEREIGNTY",
    INTEREST_RATE_FUTURE: "INTEREST_RATE_FUTURE",
    FX_PAIR: "FX_PAIR"
};

export const MARKET_PRICE_SOURCE = {
    INDICATIVE: "INDICATIVE",
    SUPPLIED: "SUPPLIED"
};

export const MAX_NUMBER_OF_DISCLAIMER_LOAD_ATTEMPTS = 15;
export const DISCLAIMER_LOAD_BACKOFF_MILLISECONDS = 500;

export const MAX_NUMBER_OF_LAST_DIFFERING_RECOMMENDATION_LOAD_ATTEMPTS = 15;
export const LAST_DIFFERING_RECOMMENDATION_LOAD_BACKOFF_MILLISECONDS = 500;


/** WEBPACK FOOTER **
 ** ./src/main/javascript/recorder/constants.js
 **/